var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.homeCome)?_c('header-nav'):_vm._e(),_c('router-view',{attrs:{"id":"main"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }